import { decryptData, encryptData } from "utils/dataCipherHelper";
import axios from "axios";
import { setHeaders } from "config/axiosInstance";

// Create Support Ticket Handler Api

export const masterRegionList = async (reqData) => {
    const responseData = await axios.get( `${process.env.REACT_APP_MASTER_URL}master/region-list?language=${reqData}`,setHeaders());
    return decryptData(responseData?.data||"");
  };

export const masterCityList = async (data) => {
  const responseData = await axios.get( `${process.env.REACT_APP_MASTER_URL}master/city-list?reqData=${encryptData(data)}`,setHeaders());
  return decryptData(responseData?.data||"");
};


export const surveyCategoryListApi = async (data) => {
  const responseData = await axios.get( `${process.env.REACT_APP_MASTER_URL}master/survey-category-list`,setHeaders());
  return decryptData(responseData?.data||"");
};


